import { createGlobalStyle } from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const GlobalStyled = createGlobalStyle`
    :root {
        --color-1: #27eed6;
        --color-2: #097366;
        --color-3: #b5f9f1;
        --color-4: #8a8a8a;

        --color-base: #171717;
        --color-main: #ffffff;

        --color-surface: #171717;
        --color-on-surface: #ffffff;

        --color-primary: #27eed6;
        --color-primary-light: #20c7b4;
        --color-on-primary: #171717;

        --color-secondary: #8f8b8b;
        --color-secondary-light: #afabab;
        --color-on-secondary: #171717;

        --color-positive: #54EEAB;
        --color-negative: #FF858B;

        --color-bg-header: #000000;
        --color-bg-modal: #000000;

        --app-bg-color: #171717;
        --color-yellow: #27eed6;
        --color-yellow-light: #20c7b4;

        --bs-primary-rgb: 9, 115, 102;
        --bs-border-radius: 2em;
    }

    html, body {
        height: 100%;
    }

    #root {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    body {
        font-family: 'FuturaPT', Arial, sans-serif;
        font-size: 18px;
        font-weight: 300;
        line-height: 1.23;

        background-color: var(--color-surface);
        color: var(--color-on-surface);
        margin: 0;
        padding: 0;
    }

    a,
    a:link {
        color: #27eed6;

        &:hover {
            color: #20c7b4;
        }
    }

    .app {
        * {
            //user-select: none !important;
        }
    }

    h1, h2, h2, h3, h4, h5, h6 {
        user-select: none;
    }

    .positive {
        color: var(--color-positive);
    }

    .negative {
        color: var(--color-negative);
    }

    /**
     * Typographic
     */

    h1 {
        font-size: 40px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 32px;
        }
    }

    h2 {
        font-size: 32px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 28px;
        }
    }

    h3 {
        font-size: 28px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 24px;
        }
    }

    h4 {
        font-size: 24px;
        font-weight: 600;
    }

    h5 {
        font-size: 20px;
        font-weight: 600;
        @media (max-width: ${BREAKPOINTS.small}px) {
            font-size: 16px;
        }
    }

    h6 {
        font-size: 16px;
        font-weight: 600;
    }

    a[type='button'] {
        -webkit-appearance: none;
    }

    .flex-row {
        display: flex;
        flex-direction: row;

        > * {
            flex: 1 1 auto;
        }
    }

    /**
     * BOOTSTRAP    
     */

    .dropdown-menu {
        background-color: var(--color-bg-modal);
        border: none;
        box-shadow: 0 4px 25px rgba(0, 0, 0, 0.25);
        border-radius: 2px;
    }

    .dropdown-divider {
        margin: 4px 8px;
        border-top: 1px solid var(--color-main);
        opacity: 1;
    }

    .dropdown-header {
        font-size: 14px;
        font-weight: 400;
        color: var(--color-main);
        padding: 12px 16px;
    }

    .dropdown-item,
    a.dropdown-item {
        font-size: 14px;
        font-weight: 600;
        color: var(--color-main);
        padding: 12px 16px;

        svg {
            margin-right: 8px;
        }

        &:focus,
        &:hover {
            color: var(--color-main);
            background: var(--color-base);
            opacity: 0.8;
        }
    }

    .carousel .slide {
        text-align: unset;
    }

    hr {
        background-color: var(--color-neutral-20);
        opacity: 1;
    }

    .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
